{
    "title": "Choose the operation type",
    "subtitle": "Feel free to create on-ramp and off-ramp transfers",
    "input": {
        "anotherwallet": "Transfer to another wallet",
        "usdaccount": "Transfer to USD account"
    }
}